const API_BASE = '/api';

const PARAM_QUESTIONNAIRE_ID = '{questionnaireId}';
const PARAM_QUESTION_ID = '{questionId}';
const PARAM_ANSWER_ID = '{questionAnswerOptionId}';
const PARAM_RESPONSE_ID = '{responseId}';
const PARAM_CULTURECODE = 'cultureCode';

const API_QUESTIONNAIRES = `${API_BASE}/questionnaires/`;
const API_QUESTIONNAIRE = `${API_QUESTIONNAIRES}${PARAM_QUESTIONNAIRE_ID}`;

const API_QUESTIONS = `${API_QUESTIONNAIRE}/questions/`;
const API_QUESTION = `${API_QUESTIONS}${PARAM_QUESTION_ID}`;

const API_RESPONSES = `${API_QUESTIONNAIRE}/responses/`;
const API_RESPONSE = `${API_RESPONSES}${PARAM_RESPONSE_ID}`;

export default {
    api: {
        questionnaire: {
            read: {
                endpoint: API_QUESTIONNAIRE,
                method: 'GET',
            },
            statuses: {
                editable: 'EditMode',
                running: 'Running',
                finished: 'Closed',
            },
        },
        question: {
            types: {
                verticalList: 1,
                horizontalScale: 2,
            },
            mediaTypes: {
                image: 'Image URL',
                youtube: 'YouTube ID',
                vimeo: 'Vimeo ID',
            },
            videoPlatforms: {
                youtube: 'YouTube',
                vimeo: 'Vimeo',
            }
        },
        answer: {
            types: {
                selectOption: 1,
                number: 2,
                textSingLine: 3,
                textMultiLine: 4,
            }
        },
        response: {
            create: {
                endpoint: API_RESPONSES,
                method: 'POST',
            },
            read: {
                endpoint: API_RESPONSE,
                method: 'GET',
            },
            update: {
                endpoint: API_RESPONSE,
                endpointFinish: `${API_RESPONSE}/setfinished`,
                method: 'PUT',
            },
        },
        parameters: {
            questionaireId: PARAM_QUESTIONNAIRE_ID,
            questionId: PARAM_QUESTION_ID,
            answerId: PARAM_ANSWER_ID,
            responseId: PARAM_RESPONSE_ID,
            cultureCode: PARAM_CULTURECODE,
        },
    },
    replaces: {
        current: '{current}',
        total: '{total}',
        selected: '{selected}',
    },
    icons: {
        success: 'success',
        warning: 'warning',
        question: 'question',
    },
    occ: {
        name: 'occ',
        value: 'allcookies',
        media: 'Media',
        event: 'iframeLoaded_',
    }
}
